export interface Note {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  categoryColor: string;
  tags: string[];
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  likes: number;
  comments: number;
  collects: number;
  image?: string;
  isPinned?: boolean;
}

export const mockNotes: Note[] = [
  {
    id: 1,
    title: 'Photoshop 图层混合模式完全指南：从入门到实战',
    excerpt: '图层混合模式是PS中最强大也最容易被忽视的功能。本文系统梳理了27种混合模式的原理、适用场景和实战技巧，附带大量案例截图。',
    category: 'Photoshop',
    categoryColor: 'bg-blue-100 text-blue-700',
    tags: ['图层混合', '蒙版', '实战技巧'],
    author: '张晓明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20male%20designer%20portrait%2C%20clean%20studio%20background%2C%20professional%20headshot%2C%20warm%20smile%2C%20creative%20professional&width=80&height=80&seq=contrib-001&orientation=squarish',
    date: '2天前',
    readTime: '8分钟',
    likes: 142,
    comments: 23,
    collects: 88,
    isPinned: true,
    image: 'https://readdy.ai/api/search-image?query=photoshop%20layer%20blending%20modes%20tutorial%20interface%2C%20professional%20digital%20editing%20workspace%2C%20colorful%20gradient%20overlays%20demonstration%2C%20modern%20software%20UI%20design%2C%20clean%20technical%20aesthetic%2C%20white%20background&width=600&height=360&seq=note-img-001&orientation=landscape',
  },
  {
    id: 2,
    title: 'AI出图工作流整理：Midjourney + PS 联动实践',
    excerpt: '记录了我最近一个月摸索出来的AI辅助设计流程，从提示词撰写、风格控制到后期精修，整套流程下来效率提升了3倍。',
    category: 'AI视觉生成',
    categoryColor: 'bg-purple-100 text-purple-700',
    tags: ['AI出图', 'Midjourney', '工作流'],
    author: '张晓明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20male%20designer%20portrait%2C%20clean%20studio%20background%2C%20professional%20headshot%2C%20warm%20smile%2C%20creative%20professional&width=80&height=80&seq=contrib-001&orientation=squarish',
    date: '4天前',
    readTime: '12分钟',
    likes: 218,
    comments: 41,
    collects: 156,
    image: 'https://readdy.ai/api/search-image?query=artificial%20intelligence%20design%20workflow%20visualization%2C%20creative%20AI%20tools%20interface%2C%20futuristic%20digital%20workspace%2C%20neural%20network%20patterns%2C%20modern%20technology%20aesthetic%2C%20clean%20white%20background&width=600&height=360&seq=note-img-002&orientation=landscape',
  },
  {
    id: 3,
    title: '钢笔工具终于用顺了！分享我的练习方法',
    excerpt: '练了两周钢笔工具，从最开始的锚点乱飞到现在能流畅勾勒复杂轮廓。总结了5个关键练习步骤，附练习素材下载。',
    category: 'Illustrator',
    categoryColor: 'bg-orange-100 text-orange-700',
    tags: ['钢笔工具', '矢量', '练习方法'],
    author: '林小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20female%20designer%20portrait%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20friendly%20expression%2C%20creative%20style&width=80&height=80&seq=contrib-002&orientation=squarish',
    date: '5天前',
    readTime: '6分钟',
    likes: 97,
    comments: 18,
    collects: 63,
    image: 'https://readdy.ai/api/search-image?query=vector%20illustration%20creation%20process%20in%20illustrator%2C%20digital%20drawing%20workspace%20with%20pen%20tool%2C%20colorful%20geometric%20shapes%20and%20paths%2C%20modern%20flat%20design%20style%2C%20creative%20workspace%20aesthetic%2C%20clean%20background&width=600&height=360&seq=note-img-003&orientation=landscape',
  },
  {
    id: 4,
    title: '视频调色入门：DaVinci Resolve 色轮使用心得',
    excerpt: '从完全不懂调色到能独立完成一条短视频的色彩处理，记录了我踩过的坑和总结的规律，重点讲了一级调色和LUT的配合使用。',
    category: '视频剪辑',
    categoryColor: 'bg-pink-100 text-pink-700',
    tags: ['调色', 'DaVinci', 'LUT'],
    author: '陈思远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20male%20student%20portrait%2C%20casual%20style%2C%20clean%20background%2C%20confident%20expression%2C%20modern%20look&width=80&height=80&seq=contrib-003&orientation=squarish',
    date: '1周前',
    readTime: '10分钟',
    likes: 76,
    comments: 14,
    collects: 52,
    image: 'https://readdy.ai/api/search-image?query=video%20color%20grading%20interface%20with%20color%20wheels%20and%20curves%2C%20professional%20video%20editing%20software%2C%20cinematic%20color%20correction%20workspace%2C%20vibrant%20color%20palette%20demonstration%2C%20modern%20post-production%20setup%2C%20clean%20background&width=600&height=360&seq=note-img-004&orientation=landscape',
  },
  {
    id: 5,
    title: 'UI设计中的间距系统：8pt 网格实践总结',
    excerpt: '用了半年8pt网格系统之后，设计稿的整洁度和开发还原度都有了明显提升。分享我的间距规范制定思路和Figma组件设置方法。',
    category: 'UI设计',
    categoryColor: 'bg-teal-100 text-teal-700',
    tags: ['间距系统', '网格', 'Figma'],
    author: '张晓明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20male%20designer%20portrait%2C%20clean%20studio%20background%2C%20professional%20headshot%2C%20warm%20smile%2C%20creative%20professional&width=80&height=80&seq=contrib-001&orientation=squarish',
    date: '1周前',
    readTime: '7分钟',
    likes: 134,
    comments: 29,
    collects: 101,
  },
  {
    id: 6,
    title: '抠图技巧大全：从简单到复杂场景全覆盖',
    excerpt: '整理了8种常用抠图方法：快速选择、通道抠图、钢笔路径、AI抠图……每种方法都标注了适用场景，帮你快速选对工具。',
    category: 'Photoshop',
    categoryColor: 'bg-blue-100 text-blue-700',
    tags: ['抠图技巧', '通道', '选区'],
    author: '林小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20female%20designer%20portrait%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20friendly%20expression%2C%20creative%20style&width=80&height=80&seq=contrib-002&orientation=squarish',
    date: '10天前',
    readTime: '9分钟',
    likes: 189,
    comments: 35,
    collects: 127,
    image: 'https://readdy.ai/api/search-image?query=photoshop%20selection%20and%20masking%20tools%20demonstration%2C%20professional%20image%20cutout%20technique%2C%20complex%20hair%20selection%20on%20clean%20background%2C%20digital%20photo%20editing%20process%2C%20modern%20software%20interface&width=600&height=360&seq=note-img-006&orientation=landscape',
  },
  {
    id: 7,
    title: '字体排版的 5 个核心原则，设计新手必看',
    excerpt: '对比、重复、对齐、亲密、留白——这五个原则贯穿了所有优秀排版设计。用大量实例拆解每个原则的实际应用方式。',
    category: 'UI设计',
    categoryColor: 'bg-teal-100 text-teal-700',
    tags: ['字体排版', '设计原则', '构图'],
    author: '陈思远',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20male%20student%20portrait%2C%20casual%20style%2C%20clean%20background%2C%20confident%20expression%2C%20modern%20look&width=80&height=80&seq=contrib-003&orientation=squarish',
    date: '2周前',
    readTime: '11分钟',
    likes: 203,
    comments: 47,
    collects: 168,
  },
  {
    id: 8,
    title: 'Stable Diffusion 本地部署踩坑记录',
    excerpt: '从环境配置到模型下载，再到第一张图出来，整个过程踩了不少坑。把所有报错和解决方案都记录下来，希望能帮到同样在折腾的你。',
    category: 'AI视觉生成',
    categoryColor: 'bg-purple-100 text-purple-700',
    tags: ['Stable Diffusion', 'AI出图', '环境配置'],
    author: '张晓明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20male%20designer%20portrait%2C%20clean%20studio%20background%2C%20professional%20headshot%2C%20warm%20smile%2C%20creative%20professional&width=80&height=80&seq=contrib-001&orientation=squarish',
    date: '2周前',
    readTime: '15分钟',
    likes: 312,
    comments: 68,
    collects: 245,
    image: 'https://readdy.ai/api/search-image?query=stable%20diffusion%20AI%20image%20generation%20interface%2C%20machine%20learning%20model%20output%20visualization%2C%20creative%20AI%20artwork%20generation%20process%2C%20modern%20technology%20workspace%2C%20neural%20network%20visualization%2C%20clean%20minimal%20background&width=600&height=360&seq=note-img-008&orientation=landscape',
  },
  {
    id: 9,
    title: '光影关系在修图中的应用：让照片更有立体感',
    excerpt: '很多人修图只会调亮度对比度，却忽略了光影关系的塑造。本文从光源方向、高光阴影分布到局部加深减淡，系统讲解如何用光影提升照片质感。',
    category: 'Photoshop',
    categoryColor: 'bg-blue-100 text-blue-700',
    tags: ['光影', '修图', '质感'],
    author: '林小雨',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20female%20designer%20portrait%2C%20clean%20white%20background%2C%20professional%20headshot%2C%20friendly%20expression%2C%20creative%20style&width=80&height=80&seq=contrib-002&orientation=squarish',
    date: '3周前',
    readTime: '8分钟',
    likes: 156,
    comments: 22,
    collects: 94,
  },
];
